<!-- 高校生成器 -->
<template>
  <div id='course'>
    <div class="schoolDesc" @click="showIframe">
      <img class="schoolImg" :src="schoolImg ? schoolImg : require('../../assets/img/none.png')" referrerpolicy="no-referrer">
      <div class="desc">{{schoolDesc || school}}</div>
      <img v-if="schoolImg" class="arr" src="@/assets/img/arr-right.png">
    </div>
    <div class="grade-tab">
      <div :class="tabClass(1)" @click="gradeChange(1)">大一</div>
      <div :class="tabClass(2)" @click="gradeChange(2)">大二</div>
      <div :class="tabClass(3)" @click="gradeChange(3)">大三</div>
      <div :class="tabClass(4)" @click="gradeChange(4)">大四</div>
    </div>
    <div class="top">
      <div class="test school">{{school}}</div>
      <span>|</span>
      <div class="test zy">{{zy}}</div>
      <!-- <div class="back" @click="$router.push('/')">重新查询</div> -->
    </div>

    <div class="course-table">
      <!-- <div class="section-column">
        <div class="fisrt-part"></div>
        <div class="number" v-for="(item,index) in section" :key='index'>
          {{item}}
        </div>
      </div>
      <div class="day-column" v-for="(item,index) in day" :key='index'>
        <div class="day-title">{{item}}</div>
        <div class="course-class" ref="course" v-for="(item,index) in section" :key='index'>
          <span></span>
        </div>
      </div> -->
      <div class="section-column">
        <div class="fisrt-part"></div>
        <div class="number" v-for="(item,index) in leftSide" :key='index'>
          {{item}}
        </div>
      </div>
      <div class="day-column" v-for="(item,index) in day" :key='index'>
        <div class="day-title">{{item}}</div>
        <div class="course-class" ref="course" v-for="(item,index) in section[index]" :key='index' @click="item !== '' ? showDownload = true : ''; courseName = item">
          <!-- <span>{{item}}{{item}}{{item}}{{item}}{{item}}{{item}}{{item}}{{item}}</span> -->
          <span>{{item}}</span>
        </div>
      </div>
      
      <div class="watermark" :style="{'backgroundImage': `url(${require('../../assets/img/watermark.png')})`}"></div>
    </div>

    <div class="foot" style="display: none;">
      <button class="enter-button" @click='creatQian'>生成许愿报考签</button>
      <div class="zl">
        <span>数据来源</span>
        <img src="@/assets/img/logo.png" alt="">
      </div>
    </div>
    <div class="fx" @click="goNewPage" style="display: none;">
      <div>课表深度分析</div>
      <!-- <img src="@/assets/img/arrow.png" alt=""> -->
      <van-icon name="arrow-down" size="24" />
    </div>

    <div class="tableTip">
      <p>以上数据是基于超级课程表APP1.27亿张课表数据模拟出来的，真实的课表信息您可以等到入学后，拿到学校统一派发的学号和密码，就可以在超级课程表导入并直接查看实时准确的课程。
      <br><br>
      每年开学季正是同学们疯狂冲进教务系统查看课表的高峰期！强烈建议你提前把课程表APP保存到你的手机里，实时准确地查看课程信息，避开教务系统的拥堵时段，错峰查看录取大学所选专业的课程信息！</p>
      <div class="btn-group">
        <div @click='trackEvent("重新查询");$router.push(`/`);'>重新查询</div>
        <div @click='trackEvent("底部下载");toDownLoad();'>下载超级课程表APP</div>
      </div>
    </div>

    <van-overlay :show="show" @click="show = false">

      <div class="wrapper" @click.stop>
        <div>
          <div class="qian" ref="htmlCanvas" v-if="!downSrc">
            <img src="@/assets/img/chang.png" alt="" class="bg">
            <div class="school">{{school}}{{zy}}</div>
            <img :src="hopeImg" alt="" class="hopeImg">
          </div>

          <img :src="downSrc" alt="" class='down' v-else>

          <div class="save" @click="show = false">
            <van-icon name="close" size="24px" />
            <div>长按保存到相册</div>
          </div>
        </div>

      </div>
    </van-overlay>
    <!-- 提示前往分享 -->
    <div class="shareTip" v-if="tipShow">
      <div class="tip-container" :style="{'backgroundImage': `url(${require('../../assets/img/layer-bg.png')})`}">
        <h4>录取大学所选专业课表已生成</h4>
        <p>同学，对不起。课表页面设置了分享才能查看。我们知道这个操作不太友好，但疫情当下，小软件生存不易，恳请你点一下分享按钮，帮我们APP宣传一下可以吗？我们向各位新同学保证，一定会做出更好用的产品免费给大家使用！</p>
        <div class="btn-group">
          <div @click="toShare(0)">分享</div>
          <div @click="toShare(1)">分享并<br>保存课程表</div>
        </div>
      </div>
    </div>
    <!-- 分享 -->
    <div class="shareTip" v-if="shareShow">
      <img class="shareIcon" src="@/assets/img/share.png" alt="">
    </div>
    <!-- 分享成功 -->
    <div class="shareTip" v-if="shareSuccess">
      <div class="tip-container success-container" :style="{'backgroundImage': `url(${require('../../assets/img/layer-bg.png')})`}"> 
        <h4>成功分享</h4>
        <p>同学，对不起！再次跳出来打断你查看超级课程表新生体验版。您可以直接点击关掉页面继续体验，但恳请你看完下面这段话，可以吗？<br><br>
        每年开学季正是同学们疯狂冲进教务系统查看课表的高峰期！强烈建议你提前把课程表APP保存到你的手机里，实时准确地查看课程信息，与此同时，你还能提前认识你的同班同学和师兄师姐，和他们交流你所关心的一切校园问题。</span></p>
        <div class="btn-group">
          <div @click='trackEvent("分享成功后下载");toDownLoad();'>点击下载超级课程表</div>
        </div>
      </div>
      <img class="close" @click="shareSuccess = false;" src="@/assets/img/close.png" alt="">
    </div>
    <!-- 提示下载APP -->
    <div class="shareTip" v-if="showDownload">
      <div class="tip-container download-container" :style="{'backgroundImage': `url(${require('../../assets/img/layer-bg.png')})`}"> 
        <h4>{{courseName}}</h4>
        <p>同学，你可能不知道，每年开学季正是同学们疯狂冲进教务系统查看课表的高峰期！强烈建议你把课程表APP提前保存到你的手机里，实时准确地查看课程信息，与此同时，你还能提前认识你的同班同学和同校师兄师姐，和他们交流你所关心的一切校园问题。</p>
        <div class="btn-group">
          <div @click='trackEvent("点击单节课程后弹窗");toDownLoad();'>点击下载超级课程表</div>
        </div>
      </div>
      <img class="close" @click="showDownload = false;" src="@/assets/img/close.png" alt="">
    </div>
    <!-- 查看更多 -->
    <!-- <div class="iframeLayer" v-show="school && iframeShow"> -->
    <div class="iframeLayer" v-show="school && iframeShow">
      <iframe id="myIframe" :src="'https://baike.baidu.com/item/' + school" frameborder="0"></iframe>
      <div class="iframe_bottom">
        <img class="back" @click="iframeReload" src="@/assets/img/home.png" alt=""></img>
        <img class="close" @click="iframeShow = false;" src="@/assets/img/close-icon.png" alt=""></img>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request.js'
import html2canvas from 'html2canvas'
import { getUrlParams } from '@/assets/js/tool.js'
import useSuperSdk from '@/assets/js/useSuperSdk.js'
import { Toast } from 'vant'

export default {
  data() {
    return {
      section: [],
      day: ['周一', '周二', '周三', '周四', '周五'],
      course: [],
      classNumber: 8,
      profession: '',
      grade: 1,
      term: '',
      year: '2020-2021',
      tips: false,
      tipsShare: false,
      showCourse: false,
      isApp: false,
      school: localStorage.getItem('school'),
      schoolId: localStorage.getItem('schoolId'),
      hasCourse: JSON.parse(localStorage.getItem('hasCourse')),
      zy: localStorage.getItem('faculty'),
      show: false,
      // imgs: [require('@/assets/img/001.png'), require('@/assets/img/002.png'), require('@/assets/img/003.png'), require('@/assets/img/004.png')],
      imgs: [require('@/assets/img/001.png'), require('@/assets/img/test.png')],
      hopeImg: '',
      downSrc: '',
      sourceId: '',
      leftSide: [],
      tipShow: false,
      shareShow: false,
      shareSuccess: false,
      showDownload: false,
      iframeShow: false,
      schoolImg: '',
      schoolDesc: '',
      courseName: ''
    }
  },
  mounted() {
    
    console.log(this.hasCourse);
    document.documentElement.scrollTop = document.body.scrollTop = 0;

    this.getSchoolDesc()
    // let that = this;
    // let iframe = document.getElementById('myIframe');
    // if (iframe.attachEvent){
    // iframe.attachEvent("onload", function(){
    //     that.getSchoolDesc()
    //   });
    // } else {
    //   iframe.onload = function(){
    //     that.getSchoolDesc()
    //   };
    // }
  
    this.getSchoolClass()
    this.tipShow = localStorage.getItem('hasShare') ? false : true;
  },
  updated() {
    // let basic = 'course-class'
    // let color = ['course-blue', 'course-pink', 'course-yellow', 'course-green']
    // let section = ['course-class-top', 'course-class-middle', 'course-class-bottom', 'course-class-one']
    // let i = 0;
    // for (let index = 0; index < this.course.length; index++) {
    //   let arr = this.course[index];
    //   arr.forEach((element) => {
    //     let randomColorIndex = parseInt(Math.random() * (3 - 0 + 1) + 0, this.classNumber)
    //     this.$refs.course[i].className = `${basic} ${color[randomColorIndex]} ${section[0]} `
    //     this.$refs.course[i].className = `${basic} ${color[randomColorIndex]} ${section[2]} `
    //     i ++
    //   })
    // }
    // for (let index = 0; index < this.course.length; index++) {
    //   let arr = this.course[index]
    //   arr = this.filterRepeatCourse(arr)
    //   arr.forEach((element) => {
    //     let randomColorIndex = parseInt(Math.random() * (3 - 0 + 1) + 0, this.classNumber)
    //     let startSection = (element.day - 1) * this.classNumber + element.sectionstart - 1
    //     let endSection = (element.day - 1) * this.classNumber + element.sectionend - 1
    //     //获取课程开始和结束
    //     // console.log((element.day-1)*this.classNumber + element.sectionstart)
    //     this.$refs.course[startSection].className = `${basic} ${color[randomColorIndex]} ${section[0]} `
    //     this.$refs.course[endSection].className = `${basic} ${color[randomColorIndex]} ${section[2]} `
    //     //获取课程中间节
    //     if (element.sectionend - element.sectionstart > 1) {
    //       for (let index = element.sectionstart + 1; index < element.sectionend; index++) {
    //         this.$refs.course[(element.day - 1) * this.classNumber + index - 1].className = `${basic} ${color[randomColorIndex]} ${section[1]} `
    //       }
    //     }
    //     //获取仅一节的课程
    //     if (element.sectionend === element.sectionstart) {
    //       this.$refs.course[startSection].className = `${basic} ${color[randomColorIndex]} ${section[3]} `
    //     }
    //     //获取课程名字
    //     if (element.name.length > 15) {
    //       element.name = element.name.substring(0, 15) + '...'
    //     }
    //     this.$refs.course[startSection].firstChild.innerHTML = `${element.name}  `
    //     this.$refs.course[startSection].firstChild.style.height = `${(element.sectionend - element.sectionstart + 1) * 50}px`
    //     // this.$refs.course[startSection].firstChild.style.marginTop =
    //     //     `${(element.sectionend - element.sectionstart + 1) * 0.3}rem`
    //   })
    // }
    // console.log(this.course)
    if (this.course.length !== 0) {
      this.showCourse = true
    }
  },
  methods: {
    wxsetShare() {
      let f = getUrlParams(location.href, 'f');
      const { setShare } = useSuperSdk()

      const school = localStorage.getItem('school')

      const faculty = localStorage.getItem('faculty')

      const sourceId = localStorage.getItem('sourceId')
 
      // const title = `看！这是我在${school}大学${faculty}专业的课表！~`

      // const link = 'https://a.super.cn/previewCourse/#/';

      // const desc = '一键了解以后要上什么课，安利你也来玩！'

      const title = '2023届大学新生课表统一查询入口'
      const link =  f == '' ? 'https://a.super.cn/previewCourse/#/' : 'https://a.super.cn/previewCourse/#/?=' + f;
      const desc = '点击提前查看录取大学所选专业课程表'

      setShare(title, link, desc)
      console.log('course页面分享配置')
    },

    async gradeChange(index){
      if(!this.hasCourse[index - 1].flag){
        return;
      }
      this.grade = index;
      const data = {
        schoolId: localStorage.getItem('schoolId'),
        specialtyName: localStorage.getItem('faculty'),
        grade: this.grade
      }
      const response = await request.post('/getCourse.action', data);
      Toast.clear()
      if (response.data) {
        response.data.school = localStorage.getItem('school')
        localStorage.setItem('response', JSON.stringify(response))
        this.getSchoolClass();
      } else {
        Toast.fail(response.message)
      }
    },

    //异步请求们
    async getSchoolClass() {
      // var response = {}
      // if (this.$route.query.sourceId) {
      //   response = await request.post('/V2/CourseGeneration/loadCourse.action', { sourceId: this.$route.query.sourceId })
      // } else {
      //   // response = await request.post('/V2/CourseGeneration/queryCourse.action', data)
      //   response = JSON.parse(localStorage.getItem('response'))
      // }
      var response = JSON.parse(localStorage.getItem('response'))
      if (response.data) {
        let lessonList = response.data

        localStorage.setItem('num1', response.data.num1)
        localStorage.setItem('num2', response.data.num2)
        localStorage.setItem('num3', response.data.num3)
        localStorage.setItem('num4', response.data.num4)
        localStorage.setItem('tag1', response.data.tag1)
        localStorage.setItem('tag2', response.data.tag2)
        localStorage.setItem('tag3', response.data.tag3)
        localStorage.setItem('tag4', response.data.tag4)
        // localStorage.setItem('faculty', response.data.faculty)
        // localStorage.setItem('school', response.data.school)
        localStorage.setItem('sameCourse', JSON.stringify(response.data.sameCourse))
        localStorage.setItem('otherCourse', JSON.stringify(response.data.otherCourse))
        console.log(response)

        let dayCourse = [];
        let arr = [];
        let arrIndex = 0;
        response.data.forEach((item,index) => {
          arr.push(item);
          if((index + 1) % 4 == 0 && index > 0){
            dayCourse.push(arr);
            arr = [];
            arrIndex ++;
          }
        })

        // this.hopeImg = this.imgs[response.data.qrCode - 1]

        // this.sourceId = response.data.sourceId

        // localStorage.setItem('sourceId', response.data.sourceId)

        // let dayCourse = [[], [], [], [], []]
        // this.classNumber = 8
        // lessonList.forEach((element) => {
        //   let needData = {
        //     day: element.day,
        //     name: element.name,
        //     sectionstart: element.sectionstart,
        //     sectionend: element.sectionend,
        //   }
        //   // console.log(needData)
        //   if (element.sectionend > this.classNumber) {
        //     this.classNumber = element.sectionend
        //   }
        //   // console.log(this.classNumber);

        //   switch (element.day) {
        //     case 1:
        //       dayCourse[0].push(needData)
        //       break
        //     case 2:
        //       dayCourse[1].push(needData)
        //       break
        //     case 3:
        //       dayCourse[2].push(needData)
        //       break
        //     case 4:
        //       dayCourse[3].push(needData)
        //       break
        //     case 5:
        //       dayCourse[4].push(needData)
        //       break
        //     default:
        //       break
        //   }
        // })
        // //获取最大课节数
        // for (let index = 0; index < this.classNumber; index++) {
        //   this.section.push(index + 1)
        // }
        this.course = dayCourse
        this.section = dayCourse;
        // let s = ['一','二','三','四','五','六','七','八'];
        let s = [1,2,3,4,5,6,7,8];
        this.leftSide = s;
        this.randomColor();

        this.wxsetShare()
        // console.log(this.course)
      } else {
        alert(response.message)
        this.$router.push(`/`)
        localStorage.setItem('isback', 'true')
      }
    },

    async getSchoolDesc(){
      const response = await request.post('/getSchoolIntro.action', {schoolId: this.schoolId})
      if(response.data.intro){
        this.schoolImg = response.data.imageUrl;
        this.schoolDesc = response.data.intro;
      }
    },

    imageUrlToBase64() {
      //一定要设置为let，不然图片不显示
      let image = new Image();
      //解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous');
      let imageUrl = "http://img1.imgtn.bdimg.com/it/u=4012470373,3540768040&fm=26&gp=0.jpg";
      image.src = imageUrl
      let that = this;
      //image.onload为异步加载
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);              
        var quality = 0.8;
        //这里的dataurl就是base64类型
        var dataURL = canvas.toDataURL("image/jpeg", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！          
      }
    },

    randomColor(){
      let basic = 'course-class'
      let color = ['course-blue', 'course-pink', 'course-yellow', 'course-green']
      let section = ['course-class-top', 'course-class-middle', 'course-class-bottom', 'course-class-one']
      let i = 0;
      this.$nextTick(()=>{
        for (let index = 0; index < this.course.length; index++) {
          let arr = this.course[index];
          arr.forEach((element) => {
            this.$refs.course[i].className = `course-class`
            if(element){
              let randomColorIndex = parseInt(Math.random() * (3 - 0 + 1) + 0, this.classNumber)
              this.$refs.course[i].className = `${basic} ${color[randomColorIndex]} ${section[0]}`
            }
            // this.$refs.course[i].className = `${basic} ${color[randomColorIndex]} ${section[2]} `
            i ++
          })
        }
      })
    },

    async creatQian() {
      // 百度统计计数
      // _hmt && _hmt.push(['_trackEvent', 'create-Class', ''])
      this.trackEvent('一键生成课表')

      document.body.scrollTop = document.documentElement.scrollTop = 0
      await request.post('/V2/CourseGeneration/makePic.action', { sourceId: this.sourceId })

      this.show = true

      // this.$nextTick(() => {
      //   html2canvas(this.$refs.htmlCanvas).then((canvas) => {
      //     const src = canvas.toDataURL('image/png')
      //     this.downSrc = src
      //   })
      // })
      setTimeout(() => {
        html2canvas(this.$refs.htmlCanvas).then((canvas) => {
          const src = canvas.toDataURL('image/png')
          this.downSrc = src
        })
      }, 200)
    },

    //去除重叠课程
    filterRepeatCourse(arr) {
      // console.log(arr)
      let courseByte = []
      let fiterArr = []
      arr.forEach((element) => {
        if (!courseByte.includes(element.sectionstart)) {
          if (!courseByte.includes(element.sectionend)) {
            fiterArr.push(element)
            for (let index = element.sectionstart; index <= element.sectionend; index++) {
              courseByte.push(index)
            }
          }
        }
      })
      // console.log(fiterArr)
      return fiterArr
    },
    goNewPage() {
      if (this.$route.query.sourceId) {
        this.$router.push({ path: '/result', query: { sourceId: this.$route.query.sourceId } })
      } else {
        this.$router.push('/result')
      }
    },

    toShare(type){
      if(type){
        this.toDownLoad();
        // _hmt && _hmt.push(["_trackEvent", "previewClass", ]);
        this.trackEvent("分享并下载")
      }
      else{
        // _hmt && _hmt.push(["_trackEvent", "previewClass", "分享"]);
        this.trackEvent("分享")
      }
      this.tipShow = false;
      this.shareShow = true;
      setTimeout(() => {
        this.shareShow = false;
        localStorage.setItem('hasShare',true)
      }, 5000);

      setTimeout(() => {
        this.shareSuccess = true;
      }, 30000);
    },
    toDownLoad(){
      window.location.href = 'http://redirect.super.cn/cjkcb/download?from=kebiao'
    },
    showIframe(){
      if(this.schoolImg){
        this.iframeShow = true
      }
    },
    iframeReload(){
      document.getElementById('myIframe').src = 'https://baike.baidu.com/item/' + this.school
    },
    //事件监听
    trackEvent(name){
      _hmt.push(["_trackEvent", "previewClass", name])
    },
    tabClass(index){
      if(this.grade == index){
        return 'active'
      }
      else if(!this.hasCourse[index - 1].flag){
        return 'gary'
      }
      else{
        return ''
      }
    }
  },
  components: {},
  watch :{
    shareShow(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    },
    tipShow(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    },
    shareSuccess(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    },
    showDownload(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    },
    iframeShow(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .down {
    width: 327px;
  }
  .qian {
    width: 327px;
    position: relative;
    .bg {
      width: 100%;
      position: relative;
    }
    .school {
      width: 221px;
      font-size: 12px;
      position: absolute;
      color: #000;
      top: 135px;
      left: 15px;
      font-weight: bold;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .hopeImg {
      width: 85px;
      position: absolute;
      bottom: 12px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .save {
    font-size: 20px;
    color: #ccc;
    margin-top: 15px;
  }
}
.shareTip{
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
  .close{
     width: 40px;
     margin-top: 40px;
  }
  .tip-container{
    width: 295px;
    height: 290px;
    left: 40px;
    top: 189px;
    background: #EAF4FF;
    border-radius: 16px;
    background-size: 100% 100%;
    background-position: top center;
    h4{
      font-size: 18px;
      font-weight: bold;
      padding: 0 16px;
      margin: 24px 0;
      color: #436EF6;
      // background: linear-gradient(90deg, #4557EF, #428AFF);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      // background-clip: text;
      // text-fill-color: transparent;
      overflow: hidden; // 溢出隐藏
      text-overflow: ellipsis; // 溢出用省略号显示
      white-space: nowrap; // 规定段落中的文本不进行换行
    }
    p{
      color: #4F70B2;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      line-height: 20px;
      padding: 0 16px;
      text-align: left;
      span{
        color: #5786FF;
      }
    }
    .btn-group{
      width: 263px;
      overflow: hidden;
      margin: 25px auto 0;
      div{
        width: 124px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #5786FF;
        font-family: PingFangSC-Regular;
        text-align: center;
        font-size: 16px;
        border-radius: 8px;
        background-color: #fff;
        float: left;
        &:last-of-type{
          color: #fff;
          font-size: 14px;
          float: right;
          background: linear-gradient(90deg, #5786FF 0%, #57AEFF 100%);
        }
      }
    }
  }
  .success-container{
    height: 381px;
    .btn-group div{
      width: 263px;
    }
  }
  .download-container{
    .btn-group{
      margin-top: 16px;
      div{
        width: 263px;
      }
    }
  }
  .shareIcon{
    width: 138px;
    position: absolute;
    right: 40px;
    top: 40px;
  }
}
.schoolDesc{
  width: 100%;
  height: 84px;
  position: relative;
  padding: 18px 24px 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: linear-gradient(178.48deg, #EBF1FF 1.29%, rgba(235, 241, 255, 0) 98.71%);
  .schoolImg{
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }
  .desc{
    width: 255px;
    color: #666;
    height: 48px;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
    position: relative;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .arr{
    width: 8px;
    padding-top: 18px;
  }
}
.iframeLayer{
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
  iframe{
    width: 327px;
    height: 80vh;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    background-color: #fff;
  }
  .iframe_bottom{
    width: 327px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    img{
      width: 24px;
      margin: 0 16px;
    }
  }
}
.tableTip{
  color: #666;
  font-size: 14px;
  line-height: 19px;
  padding: 24px;
  text-align: left;
  .btn-group{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
    div{
      width: 160px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      text-align: center;
      color: #5786FF;
      background: #EBF1FF;
      border-radius: 8px;
      &:last-of-type{
        color: #fff;
        background: #5786FF;
      }
    }
  }
}
</style>
